import { useQueryClient } from '@unifyapps/network/react-query';

import { useUserPreferenceMutation } from '@unifyapps/carbon/hooks/useUserPreferenceMutation';
import { buildGetUserPreferencePayloadRequest } from '@unifyapps/carbon/hooks/useUserPreferenceMutation/utils';
import { UAModules } from '@unifyapps/defs/types/modules';
import useEventCallback from '@unifyapps/hooks/useEventCallback';
import { getExecuteWorkflowNodeQueryKey } from '@unifyapps/network/generated/workflow-rest-api/workflow-rest-api';
import { THEME_USER_PREFERENCE_KEY } from '../../../../../const';
import { getThemeUserPreferenceTriggerInputCondition } from '../../../../useThemeUserPreference';

export function useUpdateThemeForPrivateInterface() {
  const { setUserPreference } = useUserPreferenceMutation();
  const queryClient = useQueryClient();

  const updateThemeForPrivateInterface = useEventCallback(
    async ({ interfaceId, themeId }: { themeId: string; interfaceId?: string }) => {
      if (!interfaceId) {
        return;
      }

      await setUserPreference({
        applicationId: interfaceId,
        module: UAModules.INTERFACE,
        recordId: interfaceId,
        key: THEME_USER_PREFERENCE_KEY,
        value: themeId,
      });

      // Invalidate the user-pref get query so every useThemeUserPreference instance
      // (including copilot inner GlobalAppStateStore which hosts its own
      // useSetAvailableThemesAndActiveTheme effect) refetches and observes the new
      // themeId. Without this, the get-query cache stays stale until react-query's
      // own stale-time / focus-refetch fires, leaving inner stores pinned to the
      // pre-switch theme.
      const queryKey = getExecuteWorkflowNodeQueryKey(
        buildGetUserPreferencePayloadRequest({
          triggerInputCondition: getThemeUserPreferenceTriggerInputCondition(interfaceId),
        }),
      );
      await queryClient.invalidateQueries({ queryKey });
    },
  );

  return { updateThemeForPrivateInterface };
}
